import { createSelector } from "reselect";

import { RootState } from "../../rootReducer";

export const selectFilters = createSelector(
  [(store: RootState) => store.formSubmittedSlice.createFilters],
  (data) => data
);
